"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkErrorMessage = void 0;
function checkErrorMessage(e, message) {
    return (typeof e === 'object' &&
        e !== null &&
        'message' in e &&
        typeof e.message === 'string' &&
        e.message
            .toLocaleLowerCase()
            .includes(message.toString().toLocaleLowerCase()));
}
exports.checkErrorMessage = checkErrorMessage;
//# sourceMappingURL=error.js.map